import fontColorContrast from "font-color-contrast";
import moment from "moment";

function isFirstCharacterAlphabet(str) {
  const firstCharacter = str.charAt(0);
  return /^[A-Za-z]/.test(firstCharacter);
}

const nameFormator = (name) => {
  let nameArr = name.toLowerCase().split(" ");
  if (nameArr.length === 0) {
    name = nameArr[0].charAt(0).toUpperCase() + nameArr[0].slice(1);
  } else if (nameArr.length === 1) {
    name = nameArr[0];
  } else {
    name = nameArr
      .map((namePart) =>
        isFirstCharacterAlphabet(namePart)
          ? namePart.charAt(0).toUpperCase() + namePart.slice(1)
          : namePart
      )
      .join(" ");

    // name = isFirstCharacterAlphabet(nameArr[0])
    //   ? nameArr[0]?.charAt(0).toUpperCase()
    //   : nameArr[0] +
    //     nameArr[0].slice(1) +
    //     " " +
    //     isFirstCharacterAlphabet(nameArr[1])
    //   ? nameArr[1][0].toUpperCase()
    //   : nameArr[1];
  }
  return name;
};

const makeSchedules = (schedules) => {
  let _schedules = [];
  if (schedules.length > 0) {
    _schedules = schedules.map((item) => {
      return {
        isReadOnly: true,
        id: item.id,
        calendarId: item.department_id,
        title: nameFormator(item.employeeName),
        category: "allday",
        start: item.date,
        end: item.date,
        color: fontColorContrast(item?.Department?.color),
        backgroundColor: item.departments?.color,
        attendees: [item.employeeName],
        raw: `(${moment(item.shifts.startTime, "h:mm A")
          .format("h:mmA")
          .slice(0, -1)}-${moment(item.shifts.endTime, "h:mm A")
          .format("h:mmA")
          .slice(0, -1)})`,
      };
    });
  }
  return _schedules;
};

export default makeSchedules;
